
/**
 * Default toast messages for fetching assets data.
 * 
 * These messages are displayed when the app encounters issues while fetching assets data from the server.
 * Since these errors occur before backup assets are configured, these pre-defined messages provide immediate feedback to users.
 */


export const fetchAssetsToastErrors: Record<string, string>= {
    generalWarning: "Some features may not work as expected. Using defaults",
    appSettings: "App settings could not be retrieved.",
    locationConfig: 'App "Locations" could not be retrieved.',
    logFormConfig: '"Log Form" settings could not be retrieved.',
    logTableConfig: '"Log Table" settings could not be retrieved.',
    techZoneConfig: '"Tech Zone" settings could not be retrieved.',
    uiConfig: "App UI settings could not be retrieved.",
    sheetStyles: "Print sheet styles could not be retrieved.",
    sheetTemplate: "Print sheet template could not be retrieved.",
    qrSheetStyles: "QR print sheet styles could not be retrieved.",
    qrSheetTemplate: "QR print sheet template could not be retrieved.",
    dymoStyles: "Dymo label styles could not be retrieved.",
    dymoTemplate: "Dymo label template could not be retrieved."
  };
